import type { RefObject } from 'react';
import { useEffect } from 'react';

export function useOnClickOutside(ref: RefObject<HTMLElement | null>, onClickOutside: () => void, enabled = true) {
  useEffect(() => {
    if (!enabled) return;

    const handleMouseDown = (event: MouseEvent) => {
      if (!ref.current || ref.current.contains(event.target as Node)) return;
      onClickOutside();
    };

    document.addEventListener('mousedown', handleMouseDown);
    return () => document.removeEventListener('mousedown', handleMouseDown);
  }, [ref, onClickOutside, enabled]);
}
